// import { FaBars } from 'react-icons/fa';
import { NavLink as Link } from 'react-router-dom';
import styled from 'styled-components';

// export const Nav = styled.nav`
// position : fixed;
// height: 85px;
// width : 100%;
// display: flex;
// justify-content: flex-end;
// background-size: 100% 100%;
// background-color: black;
// /*justify-content: space-between;*/
// padding: 0%;
// z-index: 12;
// /* Third Nav */
// `;

// export const NavLink = styled(Link)`
// color: white;
// display: flex;
// align-items: center;
// margin-right:30px;
// text-decoration: none;
// padding: 0 1rem;
// height: 100%;
// cursor: pointer;
// &.active {
// 	color: #000000;
// }
// `;

// export const Bars = styled(FaBars)`
// display: none;
// color: #808080;
// @media screen and (max-width: 768px) {
// 	display: block;
// 	position: absolute;
// 	top: 0;
// 	right: 0;
// 	transform: translate(-100%, 75%);
// 	font-size: 1.8rem;
// 	cursor: pointer;
// }
// `;

// export const NavMenu = styled.div`
// display: flex;
// align-items: center;
// justify-content : space-evenly;
// ${'' /* margin-left : 20rem; */}
// /* Second Nav */
// /* margin-right: 24px; */
// /* Third Nav */
// /*width: 100vw;
// white-space: nowrap;*/
// `;

export const NavBtn = styled.nav`
display: flex;
align-items: center;
margin-right: 24px;
/* Third Nav */
/* justify-content: flex-end;
width: 100vw; */
font-family: Roboto;
font-style: normal;
font-weight: normal;
@media screen and (max-width: 768px) {
  display: none;
}
`;

export const NavBtnLink = styled(Link)`
display: flex;
justify-content: center;
align-items: center;
width: 10vw;
height: 3vw;
cursor: pointer;
font-family: Karla;
color: white;
text-decoration: none;
font-size : 1.6vw;
transition: all 0.2s ease-in-out;
background: linear-gradient(258.04deg, rgba(96, 102, 255, 0.8) 0%, rgba(0, 255, 244, 0.8) 100%);
box-shadow: 0px 0px 15px rgba(255, 255, 255, 0.45);
border-radius: 30px;
flex: none;
order: 3;
flex-grow: 0;
`;
